import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { addMagicToken } from 'redux/actions/authAction';
import { onLoaderTrigger } from 'redux/actions/commonAction';
import { logoutApi } from 'redux/actions/UserLogout';
import { companyDetails } from 'utils/companyDetails';
import { getBranding } from 'config/tenantConfig';
import './SubVendorB2B.scss';

function SubVendorB2B() {
  const dispatch = useDispatch();
  const onBackBtn = () => {
    dispatch(logoutApi());
  };

  useEffect(() => {
    dispatch(onLoaderTrigger(false));
  }, []);

  const onUrlClick = () => {
    dispatch(addMagicToken());
  };
  return (
    <div>
      <Box sm={{ flexGrow: 1 }} className="mobileRes loginMain">
        <Grid container spacing={2} className="">
          <Grid item sm={6}>
            <Box
              alignItems={'center'}
              sx={{ display: { xs: 'none', sm: 'flex' } }}
              className="positionAbsolute otpLogo ml40"
            >
              <ArrowBackIcon
                className="cursor colorGrey"
                onClick={() => {
                  onBackBtn();
                }}
              />
              <img
                src={getBranding().logo || companyDetails?.companyLogo}
                className="maxWidth"
                alt="otplogo"
              />
            </Box>

            {/* ---OTP input type--- */}
            <div className="loginInput mobileBg">
              <Grid container className="justifyCenter" rowSpacing={4}>
                <Grid item sm={8} className="textCenter">
                  <div>
                    <h1 className="font600 font28 colorPrimary m0">
                      Please go to B2C portal for{' '}
                      <span className="colorYellow">Sub-vendor login</span>
                    </h1>
                    <Grid className="subvendorCard">
                      <Typography
                        onClick={onUrlClick}
                        variant={'body2'}
                        className="linkUrl cursor colorPrimary"
                      >
                        {'Click Here'}
                      </Typography>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' } }}>
            <div className="otpName"></div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default SubVendorB2B;
